export const addDashes = (input: string) => {
  let output = []
  for (let i = 0; i < input.length; i += 3) {
    const amplifier = i === 6 ? 4 : 3
    output.push(input.slice(i, i + amplifier))
  }
  return output.join("-").slice(0, 12)
}
